import { render, staticRenderFns } from "./ReservationTypeButtonsPage.vue?vue&type=template&id=59efc5b2&scoped=true&"
import script from "./ReservationTypeButtonsPage.vue?vue&type=script&lang=js&"
export * from "./ReservationTypeButtonsPage.vue?vue&type=script&lang=js&"
import style0 from "./ReservationTypeButtonsPage.vue?vue&type=style&index=0&id=59efc5b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59efc5b2",
  null
  
)

export default component.exports